export default "__VITE_ASSET__DR1LG_Du__"